import { ChangeDetectionStrategy, Component, Inject, ViewEncapsulation } from '@angular/core';
import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material/snack-bar';
import { UntilDestroy } from '@ngneat/until-destroy';
import { SnackbarData } from '../snackbar/snackbar.component';
import { DocumentsListEventsService } from 'src/app/modules/documents/components/documents-list/documents-list-events.service';
import {
  DOC_SEARCH_CRITERION,
  DocSearchCriterionsFactory,
} from 'src/app/core/factories/doc-search-criterions.factory';
import { SearchItemModel } from 'src/app/core/services/base-event-service';
import { FILTER_OPERATOR } from 'src/app/core/services/client-side-search.service';
import { DocumentsActions } from 'src/app/modules/documents/store/actions';
import { Store } from '@ngrx/store';

@UntilDestroy()
@Component({
  selector: 'app-doc-generation-snackbar',
  templateUrl: './doc-generation-snackbar.component.html',
  styleUrls: ['./doc-generation-snackbar.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
})
export class DocGenerationSnackbarComponent {
  constructor(
    @Inject(MAT_SNACK_BAR_DATA) public data: DocGenerationSnackbarData,
    private readonly store$: Store,
    public snackBarRef: MatSnackBarRef<DocGenerationSnackbarComponent>,
    private documentsListEventsService: DocumentsListEventsService,
    private docSearchCriterionsFactory: DocSearchCriterionsFactory,
  ) {}

  close() {
    this.snackBarRef.dismiss();
  }

  viewDoc() {
    const criterion = this.docSearchCriterionsFactory.getById(DOC_SEARCH_CRITERION.NAME);
    const filters: SearchItemModel[] = [
      {
        criterion: criterion.id,
        operator: FILTER_OPERATOR.Contains,
        type: criterion.type,
        searchValue: this.data.docName,
        controlName: criterion.controlName,
      } as SearchItemModel,
    ];

    this.documentsListEventsService.saveFilters(filters);

    this.store$.dispatch(DocumentsActions.getDocuments());
  }

  downloadDoc() {
    this.store$.dispatch(
      DocumentsActions.downloadDocument({
        uniqueId: this.data.uniqueId,
        fileName: this.data.docName,
      }),
    );
  }
}

export interface DocGenerationSnackbarData extends SnackbarData {
  docName: string;
  uniqueId: string;
}
